<div class="page-header" [class.page-header--divider]="showDivider">
  <div class="page-header__left">
    <h2 class="page-header__title">{{ title }}</h2>
    <p *ngIf="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
  </div>
  <div class="page-header__actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
